import React, { createContext, useState, useEffect, useContext } from 'react';
import firebase from 'gatsby-plugin-firebase';

const AuthContext = createContext();

function AuthProvider({ children }) {
  const [user, setUser] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setUser(user);
      setLoaded(true);
    });
  }, []);

  return <AuthContext.Provider value={{ user, setUser, loaded }}>{children}</AuthContext.Provider>;
}

export default AuthProvider;

const useAuth = () => {
  return useContext(AuthContext);
};

export { useAuth, AuthContext };
